import { FeedItemViewershipDTO } from '../dtos/FeedItemViewership.dto';
import { FeedItemViewershipModel } from '../models/FeedItemViewership.model';

export class FeedItemViewershipUtils {
  public static mapToViewModel(
    dto: FeedItemViewershipDTO,
  ): FeedItemViewershipModel {
    return {
      totalViews: dto.views,
      uniqueViews: dto.unique,
      viewership: dto.viewership,
    };
  }
}
